import { queryClient } from "#app/http/ReactQueryProvider";
import { showErrorToast } from "#app/notifications";
import { AccessTokenSingleton } from "#modules/auth/domain/AccessTokenSingleton";
import { ROUTES } from "#shared/routes";

const USER_DISABLED_TOAST_ID = "user-disabled";

export const handleDisabledUser = async () => {
  const hasAlreadyLoggedOut = AccessTokenSingleton.getInstance().getAccessToken() === null;
  if (hasAlreadyLoggedOut) {
    return;
  }

  AccessTokenSingleton.getInstance().resetToken();
  queryClient.clear();
  showErrorToast({
    id: USER_DISABLED_TOAST_ID,
    title: "Compte désactivé",
    message: "Votre accès à Fabera a été suspendu. Contactez votre administrateur ou Fabera.",
    autoClose: false,
    color: "orange",
  });

  const { router } = await import("#app/routes/router");
  await router.navigate(ROUTES.login);
};
